import { useState, useEffect } from 'react';

import { getLostOrders } from '../../../actions/orders';
import { formatMonth } from '../../../helpers/admin/adminHelper';

import PedidosFiltro from './PedidoAbandonado/PedidosFiltro';
import PedidoAbandonadoDialog from './PedidoAbandonadoDialog';
// import PedidosEstatus from './PedidoAbandonado/PedidosEstatus';
import PedidosExportacion from './PedidoAbandonado/PedidosExportacion';
import PedidosFiltroAplicado from './PedidoAbandonado/PedidosFiltroAplicado';

import { Box, Container, Backdrop, CircularProgress, Divider } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import MaterialTable, { MTableToolbar } from "material-table";
//Table
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';

import { adminOrder } from '../../../constants/constants';
import { INCOMPLETE_ORDER_TABLE_COLUMNS } from '../../../constants/admin/order_constants';

const ROW_COLORS = {
    'Pendiente de pago': '#BBDEFB',
    'Cancelado': '#FFE0B2',
    'Rechazado': '#EF9A9A',
    'No realizado': '#F0F0F0',
    'Devolución': '#E3F6E8'
};

const rowStyle = rowData => {
    const statusColor = ROW_COLORS[rowData.payment_status] || '#B0BEC5';

    if (rowData.payment?.has_errors)
        return { backgroundColor: '#FFF8DC' };
    
    return {
        backgroundColor: statusColor
    };
};

const PedidosIncompletos = () => {
    // estado de Dialog pedido seleccionado
    const [dialog, setDialog] = useState(false);
    // estado de Backdrop => carga de pedidos
    const [backdrop, setBackdrop] = useState(false);
    // estado de Dialog exportación pedidos
    const [open, setOpen] = useState(false);

    // pedidos filtrados
    const [data, setData] = useState([]);
    // pedido seleccionado
    const [selectedOrder, setSelectedOrder] = useState(adminOrder);
    // caché de pedidos
    const [ordersCache, setOrdersCache] = useState([]);

    // mes y año actual para filtro de opciones a usuario
    const [currentDate, setCurrentDate] = useState({
        years: [], today: new Date(), currentYear: 0, currentMonth: 0
    });

    // filtros en pedidos
    const [filter, setFilter] = useState({
        year: '', months: [], statuses: []
    });
    const { year, months, statuses } = filter;

    // último filtro utilizado
    const [previousFilter, setPreviousFilter] = useState({
        year: '', months: [], statuses: []
    });

    useEffect(() => {
        myOrders(); // extraer más pedidos
    }, []);

    useEffect(() => {
        // establecer último filtro utilizado
        setPreviousFilter(e => ({
            ...e,  year, months, statuses
        }));
        // actualizar información en tabla mediante filtros seleccionados
        setData(
            months.flatMap(month => {
                const key = `${year}-${formatMonth(month)}`;
                const array = ordersCache[key] || [];
                return array.filter(e => (
                    statuses.includes(e.payment_status) ||
                    (
                        statuses.includes("Error con pago")
                        && e.payment.has_errors
                    )
                ));
            }
        ));
    }, [ordersCache]);

    // pedidos perdidos y carrito abandonado
    const myOrders = async()  => {
        await getLostOrders(
            setCurrentDate, setFilter, setOrdersCache
        );
    };

    // pedido seleccionado
    const selected = (order_num) => {
        const FullOrder = data.find(e => e.order_num === order_num);
        if (FullOrder) {
            setSelectedOrder(FullOrder);
            setDialog(true);
        }
    };

    return (
        <Container maxWidth="xxl" sx={{ mb: 5, mt: '90px' }}>
            {/* <PedidosEstatus />
            <Divider sx={{ my: 2 }} /> */}

            <PedidosFiltro
                ordersCache={ordersCache}
                setOrdersCache={setOrdersCache}
                setData={setData}
                currentDate={currentDate}
                filter={filter}
                setFilter={setFilter}
                previousFilter={previousFilter}
                setPreviousFilter={setPreviousFilter}
                setBackdrop={setBackdrop}
                setOpen={setOpen}
            />

            <PedidosFiltroAplicado
                previousFilter={previousFilter}
            />

            <Divider sx={{ my: 4 }} />

            <Box sx={{ width: '100%', height: '100%' }}>
                <MaterialTable
                    title="Pedidos no completados"
                    data={data}
                    columns={INCOMPLETE_ORDER_TABLE_COLUMNS}
                    options={{
                        // exportButton: true,
                        // exportCsv: exportCsv('carrito_abandonado.csv'),
                        filtering: true,
                        headerStyle: {
                            zIndex: 1
                        },
                        rowStyle: rowStyle
                    }}
                    components={{
                        Toolbar: props => (<MTableToolbar {...props} classes={{ root: "dummy-class" }} />),
                    }}
                    localization={{
                        body: {
                            emptyDataSourceMessage: "No hay datos por mostrar",
                            addTooltip: 'Agregar',
                            deleteTooltip: 'Eliminar',
                            editTooltip: 'Editar',
                            filterRow: {
                                filterTooltip: 'Filtrar'
                            },
                            editRow: {
                                deleteText: '¿Segura(o) que quiere eliminar?',
                                cancelTooltip: 'Cancelar',
                                saveTooltip: 'Guardar'
                            }
                        },
                        grouping: {
                            placeholder: "Arrastre un encabezado aquí para agrupar",
                            groupedBy: 'Agrupado por:'
                        },
                        header: {
                            actions: 'Acciones'
                        },
                        pagination: {
                            labelDisplayedRows: '{from}-{to} de {count}',
                            labelRowsSelect: 'filas',
                            labelRowsPerPage: 'Filas por página:',
                            firstAriaLabel: 'Primera página',
                            firstTooltip: 'Primera página',
                            previousAriaLabel: 'Página anterior',
                            previousTooltip: 'Página anterior',
                            nextAriaLabel: 'Página siguiente',
                            nextTooltip: 'Página siguiente',
                            lastAriaLabel: 'Última página',
                            lastTooltip: 'Última página'
                        },
                        toolbar: {
                            addRemoveColumns: 'Agregar o eliminar columnas',
                            nRowsSelected: '{0} fila(s) seleccionada(s)',
                            showColumnsTitle: 'Mostrar columnas',
                            showColumnsAriaLabel: 'Mostrar columnas',
                            exportTitle: 'Exportar',
                            exportAriaLabel: 'Exportar',
                            exportName: "Exportar como CSV",
                            exportPDFName: "Exportar como PDF",
                            searchTooltip: 'Buscar',
                            searchPlaceholder: 'Buscar'
                        }
                    }}
                    actions={[
                        {
                            icon: () => <RemoveRedEyeIcon />,
                            tooltip: 'Ver pedido',
                            onClick: (event, rowData) => {
                                selected(rowData.order_num)
                            }

                        },
                        {
                            icon: () => <FileDownloadIcon />,
                            tooltip: 'Exportar CSV',
                            isFreeAction: true,
                            onClick: () => setOpen(true)
                        }
                    ]}
                />

                <PedidoAbandonadoDialog
                    selectedOrder={selectedOrder}
                    dialog={dialog}
                    setDialog={setDialog}
                />
            </Box>

            <PedidosExportacion
                open={open}
                setOpen={setOpen}
                data={data}
            />

            <Backdrop
                sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
                open={backdrop}
                onClick={ () => setBackdrop(false) }
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </Container>
    );
};

export default PedidosIncompletos;
